module.exports = __webpack_public_path__ + "img/187.6a7c814d.png";